// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed, fontNormal } from "@fdr/static-ui/Typography";

export const OddsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  margin-right: 12px;
  ${({ showBorder }) =>
    showBorder &&
    css`
      border-bottom: 1px solid ${buildColor("grey", "300")};
    `};
`;

export const OddsInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 320px) {
    flex-direction: column;

    & > div:last-child {
      margin-top: 8px;
    }
  }
`;

export const OpeningOdds = styled.span`
  text-transform: uppercase;
  display: flex;
  font-size: 12px;
  letter-spacing: 0.8px;
  font-family: ${fontCondensed};
  color: ${buildColor("grey", "800")};
`;

export const Odd = styled.span`
  font-size: 12px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "900")};
  margin-left: 4px;
`;

export const OddsTrend = styled.div`
  font-family: ${fontCondensed};
  font-size: 12px;
  margin-top: 5px;
  letter-spacing: normal;
  text-transform: uppercase;
  color: ${buildColor("grey", "800")};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;

  & > svg {
    margin-right: -4px;
  }
`;

export const TrendsContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  margin-left: 4px;

  & > span {
    font-size: 12px;
  }
`;

export const TrendWrapper = styled.div`
  display: flex;
  align-items: center;

  & > span {
    margin: 0;
  }
`;

export const AnalystsComment = styled.span`
  font-family: ${fontNormal};
  margin-top: 10px;
  font-size: 12px;
  color: ${buildColor("grey", "900")};
`;

export const WinProbOnRace = styled.button`
  background-color: transparent;
  color: ${buildColor("grey", "800")};
  font-size: 12px;
  font-family: ${fontCondensed};
  height: 16px;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
  white-space: nowrap;

  & > span {
    font-size: 14px;
    color: ${buildColor("grey", "900")};
    font-family: ${fontNormal};
    margin-left: 2px;
    display: flex;
    align-items: center;

    & svg {
      margin-left: 4px;
    }
  }
`;

export const WinProbOddsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
`;

export const WinProbWrapper = styled.div``;

export const WinProbRaceOff = styled.button`
  background-color: transparent;
  color: ${buildColor("grey", "800")};
  font-size: 12px;
  font-family: ${fontCondensed};
  height: 16px;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
  white-space: nowrap;

  & > span {
    font-size: 14px;
    color: ${buildColor("grey", "900")};
    font-family: ${fontNormal};
    margin-left: 2px;
    display: flex;
    align-items: center;

    & svg {
      margin-left: 4px;
    }
  }
`;
